import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Axios from 'axios'
import EventHub from './services/event-hub'
import Mgr from './services/auth'

import "@/styles/fontStyling.scss";
import "@/styles/spacing.scss";
import "@/styles/layout.scss";
import "@/styles/mouse.scss";
import "@/styles/validation.scss";
import "@/styles/ag-grid.scss";

Vue.config.productionTip = false
Vue.prototype.$http = Axios
Vue.prototype.$eventHub = EventHub

Vue.directive('resman-ellipses-title', {
  bind: function (el) {
    el.addEventListener('mouseover', function (evt) {
      let targetEl = evt.target;
      if (targetEl.offsetWidth < targetEl.scrollWidth) {
        targetEl.setAttribute('title', evt.target.textContent);
      } else {
        targetEl.hasAttribute('title') && targetEl.removeAttribute('title');
      }
    });
  }
});

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

let mgr = new Mgr()

router.afterEach(() => { // (to, from) can be passed to function if needed
  mgr.getUser()
    .then(user => {
      let timeout = Math.floor(Date.now() / 1000) + 900
      if (timeout > user.expires_at) { // checks if token is due to expire in 15 mins or less, and will sliently renew on a change of route
        mgr.renewToken()
          .then(user => {
            store.dispatch('changeUser', user)
          })
      }
    })
    .catch(err => {
      console.log(err)
    })
})
